export const LOG_AMPLITUDE_EVENTS = false;
export const PRODUCT_NAMES = {
  Tornado: 'Tornado',
};

export const PRODUCT_NAME = PRODUCT_NAMES.Tornado;

export const DOMAIN = 'https://tornado.com';

export const PRODUCT_FONTS = {
  [PRODUCT_NAMES.Tornado]: {
    normal: 'Bolton, Arial',
    bold: 'Bolton, Arial',
    thin: 'Bolton, Arial',
  },
};

export const FONT = PRODUCT_FONTS[PRODUCT_NAME];
